import React from 'react';

// Simple wrapper components using Tailwind CSS
export const AvatarWrapper: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => (
  <div className={`flex overflow-auto pb-4 min-h-[56px] gap-4 ${className}`}>
    {children}
  </div>
);

export const TagWrapper: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => (
  <div className={`flex gap-1 ${className}`}>
    {children}
  </div>
);
